export enum StaticEnvironmentKeysEnum {
  CUBEJS_API_ENDPOINT = 'cubejs_api_endpoint',
  DEBUG = 'debug',
}
